<!-- 首页 -->
<template>
  <div>
    <div class="head">
      <div class="cityName" @click="toLocation">
        <van-icon name="location-o" class="icon"/>{{cityName}}
      </div>
      <div class="search">
        <van-search v-model="form.keyword" placeholder="请输入搜索关键词" class="search-input"/>
<!--        <newInput v-model="form.keyword"></newInput>-->
      </div>
    </div>
    <div class="tab">
      <div :class="{active: activeName === 'hot'}" @click="changeTab('hot')">热映</div>
      <div :class="{active: activeName === 'new'}" @click="changeTab('new')">即将上映</div>
    </div>

    <div v-if="filmList1.length && activeName === 'hot'">
      <div class="content-head">
        <div v-if="filmList1[0]" class="file-poster0">
          <van-image
              fit="aspectFill"
              :src="filmList1[0].poster"
              @click="toBuy(filmList1[0])"
          >
            <template v-slot:loading>
              <van-loading type="spinner" size="20" />
            </template>
          </van-image>
        </div>
        <div class="head-right">
          <div v-if="filmList1.length > 1 && filmList1[1]" class="file-poster1">
            <van-image
                fit="aspectFill"
                :src="filmList1[1].poster"
                @click="toBuy(filmList1[1])"
            >
              <template v-slot:loading>
                <van-loading type="spinner" size="20" />
              </template>
            </van-image>
          </div>
          <div v-if="filmList1.length > 2 && filmList1[2]" class="file-poster1">
            <van-image
                fit="aspectFill"
                :src="filmList1[2].poster"
                @click="toBuy(filmList1[2])"
            >
              <template v-slot:loading>
                <van-loading type="spinner" size="20" />
              </template>
            </van-image>
          </div>
        </div>
      </div>

      <div class="film-list" v-if="filmList1.length && activeName === 'hot'">
        <van-list
            v-model="loading"
            :finished="finished"
            finished-text="没有更多了"
            @load="getFilesList"
        >
          <div v-for="(item,index) in filmList1" :key="item.id"  v-if="index > 2" class="list-item" @click.stop="toDetail(item)">
            <div class="item-image">
              <van-image
                  fit="aspectFill"
                  :src="item.poster"
              >
                <template v-slot:loading>
                  <van-loading type="spinner" size="20" />
                </template>
              </van-image>
            </div>
            <div class="item-content">
              <div class="content-text">
                <div class="film-name">{{item.name}}</div>
                <div>观众评分：<span style="color:#FFAA50">{{item.score || '未评分'}}</span></div>
                <div>导演：{{item.director || '未知'}}</div>
                <div>主演：{{item.leadingRole || '未知'}}</div>
              </div>
              <div class="content-btn">
                <van-button type="info" size="nomal" @click.stop="toBuy(item)" style="width:100%">特惠购票</van-button>
              </div>
            </div>
          </div>
        </van-list>
      </div>
    </div>
    <div class="film-list" v-if="filmList2.length && activeName === 'new'">
      <van-list
          v-model="loading"
          :finished="finished"
          finished-text="没有更多了"
          @load="getFilesList"
      >
        <div v-for="(item) in filmList2" :key="item.id" class="list-item" @click.stop="toDetail(item)">
          <div class="item-image">
            <van-image
                fit="aspectFill"
                :src="item.poster"
            >
              <template v-slot:loading>
                <van-loading type="spinner" size="20" />
              </template>
            </van-image>
          </div>
          <div class="item-content">
            <div class="content-text">
              <div class="film-name">{{item.name}}</div>
              <div>观众评分：<span style="color:#FFAA50">{{item.score || '未评分'}}</span></div>
              <div>导演：{{item.director || '未知'}}</div>
              <div>主演：{{item.leadingRole || '未知'}}</div>
            </div>
            <div class="content-btn">
              <van-button type="info" size="nomal" @click.stop="toDetail(item)" style="width:100%">查看</van-button>
            </div>
          </div>
        </div>
      </van-list>
    </div>

  </div>
</template>

<script>
import {getMovieList} from '@/api/cinema'
import newInput from '@/components/newInput'
export default {
  name: "home",
  components: {newInput},
  props: {},
  data() {
    return {
      activeName: 'hot',
      form: {
        keyword: '',
        page:1,
        page_size:6
      },
      finished: false,
      loading: false,
      filmList1: [], //热映中电影列表
      filmList2: [], //待上映电影列表
    }
  },
  methods: {
    setCityName(){
      if (!this.$store.state.city.hasMounted) {
        // 逻辑代码...
        let obj = window.SITE_CONFIG['theRequest'];
        if( obj.cityName === undefined || obj.cityName === null || obj.cityName === "" || obj.cityName === 'undefined' ){}
        else{ this.$store.state.city.cityName  = decodeURI(obj.cityName);
        }
        this.$store.state.city.hasMounted = true; //只需要转一次码
      }
    },
    // 选择tab
    changeTab(name){
      this.activeName = name
      this.form.page = 1
      this.loading = false
      this.finished = false
      this.filmList1 = []
      this.filmList2 = []
      this.getFilesList()
    },
    // 获取列表
    getFilesList() {
      let form = {}
      form.type = this.activeName === 'hot' ? 0 : 1
      form.page = this.form.page
      form.page_size = this.form.page_size
      form.keyword = this.form.keyword
      form.city_id = this.cityId
      this.$Toast.loading({
        message: '加载中...',
        forbidClick: true,
        duration: 0,
      });
      this.loading = true;
      getMovieList(form).then(res=>{
        // console.log('返回结果为：',res)
        if(res?.data?.list?.length){
          let list = res.data.list || [];
          if(form.type){
            this.filmList2.splice(this.filmList2.length, 0, ...list)
            // this.$set(this, 'filmList2', this.filmList2);
          }else{
            this.filmList1.splice(this.filmList1.length, 0, ...list)
            // this.$set(this, 'filmList1', this.filmList1);
          }
          this.finished = list.length < 6;
        }
        this.form.page ++;
      }).catch(e=>{
        console.log(e)
        if(form.type){
          this.filmList2 = []
        }else{
          this.filmList1 = []
        }
      }).finally(()=>{
        this.loading = false;
        this.$Toast.clear()
      })
    },
    toBuy(item){
      this.$router.push({
        path:'/cinemaList',
        query:{
          movieId:item.movieId,
          cityId:this.cityId
        }
      })
    },
    toDetail(item){
      this.$router.push({
        path:`/filmDetail`,
        query:{
          movieId:item.movieId
        }
      })
    },
    toLocation(){
      this.$router.push({
        path:'/location'
      })
    },
    // 获取坐标
    getCoordinates(){
      if ("geolocation" in navigator) {
        // 支持 geolocation
        let that = this
        navigator.geolocation.getCurrentPosition(
            (position) => {
              console.log("Latitude:", position.coords.latitude);
              console.log("Longitude:", position.coords.longitude);
              that.$store.state.city.cityPosition = {
                latitude:position.coords.latitude,
                longitude:position.coords.longitude,
              }
            },
            (error) => {
              console.error("获取坐标失败:", error);
            }
        );
      } else {
        console.error("浏览器不支持获取坐标.");
      }
    },

  },
  created() {
    this.$store.state.cinema.mobile = window.SITE_CONFIG['mobile']
    this.$store.state.cinema.code = this.$route.query.code
    this.getCoordinates()
  },
  mounted() {
    this.getFilesList()
    this.setCityName()
  },
  computed: {
    cityName(){
      return this.$store.state.city.cityName
    },
    cityId(){
      let id = ''
      if(this.cityList.length && this.cityName){
        this.cityList.map(item=>{
          if(item.cityName === this.cityName){
            id = item.cityCode
          }
        })
      }
      // console.log(id)
      return id
    },
    cityList(){
      return this.$store.state.cinema.cityList
    },
  },
  watch: {
    'form.keyword':{
      handler(){
        this.form.page = 1
        this.loading = false
        this.finished = false
        this.filmList1 = []
        this.filmList2 = []
        this.getFilesList()
      }
    }
  }
}
</script>

<style lang="less" scoped>
  .head{
    display: flex;
    justify-content: flex-start;
    align-items: center;
    font-size:28px;
    padding:15px 30px;
    .cityName{
      margin-right:15px;
      background-color: #f7f7f7;
      border-radius: 40px;
      padding: 15px 40px;
      .icon{
        margin-right:10px;
      }
    }
    .search{
      flex:1;
      .search-input{
        font-size:28px;
        input[type='search']{
          font-size:28px!important;
        }
      }
    }
  }

  .tab{
    display: flex;
    justify-content: center;
    align-items: center;
    font-size:28px;
    padding:15px 30px;
    margin-top:-25px;
    &>div{
      line-height: 50px;
      &:first-child{
        margin-right:30px;
        border-color: #5EA7E5;
        color:#5EA7E5;
      }
      &:last-child{
        border-color:#E95D32;
        color:#E95D32;
      }

    }
    .active{
      border-bottom:5px solid;
      font-weight: bold;
    }
  }

  .content-head{
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding:20px;
    border-top:1px solid #F5F5F5;
    border-bottom:1px solid #F5F5F5;
    &>div {
      &:first-child {
        flex: 0 0 64%;
        margin-right: 4%;
      }

      &:last-child {
        flex: 0 0 32%;
      }
    }
    .head-right {
      display: flex;
      justify-content: space-between;
      align-items: center;
      flex-direction: column;

      &>view {
        flex: 1 1 auto;

        &:first-child {
          margin-bottom: 20rpx;
        }
      }
    }
    .file-poster0{
      overflow: hidden;
      border-radius: 40px;
    }
    .file-poster1{
      overflow: hidden;
      border-radius: 26px;
      &:first-child{
        margin-bottom:13%;
      }
    }
  }
  .film-list {
    display: block;
    padding:0 20px;
    .list-item {
      padding: 20px 0;
      border-bottom: 1px solid #F5F5F5;
      display: flex;
      justify-content: flex-start;
      align-items: center;
      &:last-child{
        border:none;
      }
      .item-image {
        flex: 0 0 170px;
        margin-right: 20px;
        overflow: hidden;
        border-radius: 26px;
      }

      .item-content {
        flex: 1 1 auto;
        display: flex;
        justify-content: flex-start;
        align-items: center;

        .content-text {
          flex: 1 1 auto;
          width: 330px;
          color: #A1A2A1;
          font-size: 24px;

          .film-name {
            font-size: 32px;
            color: #000000;
          }

          &>div {
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
            margin: 10px 0;
          }

        }

        .content-btn {
          flex: 0 0 170px;
          margin-left: 20px;
        }
      }
    }
  }
</style>
